

































































import { Component, Vue, Prop } from "vue-property-decorator";
import SolicitacaoModel, { SolicitacaoDados } from "@/models/Solicitacao";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import firebase from "firebase";
import { UserDb } from "../models/User";
import _debug from "debug";

const debug = _debug("Mediacao:components:SolicitacoesList.vue");

const userModule = getModule(UserModule, store);

export interface SolicitacaoComParte extends SolicitacaoDados {
    parte: UserDb;
}

@Component({
    components: {},
})
export default class SolicitacoesList extends Vue {
    @Prop() public carregandoSolicitacoes!: boolean;
    @Prop() public solicitacoes!: SolicitacaoComParte[];
    @Prop() public podeAdicionar!: boolean;
    @Prop() public podeEditar!: boolean;
    @Prop() public poderPegarSolicitacao!: boolean;
    @Prop({ default: "Solicitações Abertas" }) public titulo!: string;

    private solicitacoesFiltradas: SolicitacaoModel[] = [];

    public adicionaSolicitacao() {
        debug("adicionando...");
        this.$emit("adicionarSolicitacao");
    }

    public editarSolicitacao(solicitacao: SolicitacaoModel) {
        this.$emit("editarSolicitacao", solicitacao);
    }

    public pegarSolicitacao(solicitacao: SolicitacaoModel) {
        debug("pegar solicitação no filho");
        this.$emit("pegarSolicitacao", solicitacao);
    }
}
